import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import "../../../../styles/pages-styles/main-dashboard-pages-styles/question-pages-styles/exam-pages-styles/MockExamResultPage.css"

const MockExamResultPage = () => {
    const location = useLocation();
    const { state } = location;
    const navigate = useNavigate();

    useEffect(() => {
        const handleBackButton = (event) => {
            event.preventDefault();
            navigate("/mock-exam-instruction"); // Redirect user to instruction page
        };

        window.history.pushState(null, null, window.location.href);
        window.addEventListener("popstate", handleBackButton);

        return () => {
            window.removeEventListener("popstate", handleBackButton);
        };
    }, [navigate]);
    
    if (!state) {
        return <div>No results to display.</div>;
    }

    const { score, totalQuestions, isPassed, results } = state;

    return (
        <div className="result-container">
            <h2 className="result-title">Exam Results</h2>
            <p className="result-summary">
                You scored {score} out of {totalQuestions} ({((score / totalQuestions) * 100).toFixed(2)}%). You {isPassed ? "passed" : "failed"}.
            </p>
            <ul className="result-list">
                {results.map((result, index) => (
                    <li key={index} className={`result-item ${result.isCorrect ? 'correct' : 'incorrect'}`}>
                        <p><strong>Question:</strong> {result.questionText}</p>
                        <p><strong>Your Answer:</strong> {result.userAnswer}</p>
                        <p><strong>Correct Answer:</strong> {result.correctAnswer}</p>
                        <p><strong>Result:</strong> {result.isCorrect ? 'Correct' : 'Incorrect'}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default MockExamResultPage;